import React from 'react'
import { Redirect } from 'react-router-dom'
import { getItem } from '../../../api/utils'
import {
  Table,
  Row,
  Col,
  Button,
  Tag,
  Icon,
  Modal
} from 'antd'
import API from '../../../api/index'
import Action from './Action'


const PersonsList = (props) => {
  const [redirect, setRedirect] = React.useState(undefined)
  const [persons, setPersons] = React.useState([])
  const [page, setPage] = React.useState(1)
  const [name, setName] = React.useState(undefined)
  const [Delete, setDelete] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(undefined)
  const type = getItem('type')
  const id = props.id
  const columns = [
    { title: '#', dataIndex: 'key', key: 'key'},
    {title: 'Nombre', dataIndex: 'name', key: 'name'},
    {title: 'Ciudad', dataIndex: 'cityName', key: 'cityName'},
    {title: 'Activo', dataIndex: 'is_active', key: 'is_active',
      render: (text, record) => {
        return (
          <span>
            {record.is_active ? (
              <Icon type='check-circle' theme='twoTone' twoToneColor='#52c41a' />
            ) : (
              <Icon type='close-circle' theme='twoTone' twoToneColor='red' />
            )}
          </span>
        )
      }
    },
    {title: 'Acción', dataIndex: 'action', key: 'action',
      render: (text, record) => {
        return (
          <span>
            <Tag color='blue' onClick={() => handleViewPerson(record._id, record.profession)}>Ver detalle</Tag>
            <Tag color='orange' onClick={() => handleUpdatePerson(record._id, record.profession)}>Editar</Tag>
            <Action persons={record} />
            {type === 'Administrador' && (
              <Tag color='#848C8B' onClick={() => handleDelete(record._id)}>Eliminar</Tag>
            )}
          </span>
        )
      }
    }
  ]

  const onBack = () =>{
    setRedirect('/profession')
  }

  const handleDelete = async (id) => {
    setDelete(true)
    setDeleteId(id)
  }

  const handlePersonsDelete = async () => {
    const result = await API.persons.deletes(deleteId)
    if (result.nModified === 1) {
      setDelete(false)
      setDeleteId(undefined)
      Modal.success({
        title: 'La persona ha sido eliminado exitosamente'
      })
    }
  }

  const handleAlertNot = () => {
    setDelete(false)
    setDeleteId(undefined)
  }

  const Persons = async (page, id) => {
    const response = await API.persons.listProfession(page, id)
    setPersons(response)
  }

  const handleDownload = async () => {
    const users = 'persons'
    const result = await API.csv.download({
      model: users
    })
    if (result._id) {
      Modal.success({
        title: 'Descarga archivo csv',
        content: `El archivo csv fue enviado a su email exitosamente`
      })
    }
  }

  const handleCreatePersons = () => {
    setRedirect(`/persons/create`)
  }

  const handleViewPerson = (id, profession) => {
    setRedirect(`/persons/detail/${id}/${profession}`)
  }

  const handleUpdatePerson = (id, profession) => {
    setRedirect(`/persons/update/${id}/${profession}`)
  }

  const handlePrev = () => {
    if (page >= 1) {
      const pageTemp = page - 1
      setPage(pageTemp)
      Persons(pageTemp, id)
    }
  }

  const handleNext = () => {
    if (persons.length >= 10) {
      const pageTemp = page + 1
      setPage(pageTemp)
      Persons(pageTemp, id)
    }
  }

  const profession = async (id) => {
    const detail = await API.profession.detail(id)
    setName(detail.name)
  }

  React.useEffect(() => {
    Persons(page, id)
    profession(id)
  }, [])

  if (redirect) {
    return (<Redirect to={redirect} />)
  }

  return (
    <div>
      <Row style={{ marginBottom: '20px' }}>
        <Col span={8}>
          <h3><strong>Personas de profesión {name}</strong></h3>
        </Col>
        <Col span={8} offset={8} style={{ textAlign: 'right' }}>
          <Button onClick={() => handleDownload()}>Descargar csv</Button>
          {' '}
          <Button onClick={() => onBack()}>Regresar</Button>
          {' '}
          <Button onClick={() => handleCreatePersons()}>Crear persona</Button>
        </Col>
        {Delete && (
          <Modal
            title='Alerta'
            visible={Delete}
            onOk={() => handlePersonsDelete()}
            onCancel={() => handleAlertNot()}
            okText='Continuar'
            cancelText='Cancelar'
          >
            <p>¿Desea eliminar esta persona?</p>
          </Modal>
        )}
      </Row>
      <Table
        columns={columns}
        dataSource={persons}
        size='small'
        pagination={{
          position: 'none'
        }}
      />
     <div style={{
        textAlign: 'right',
        marginTop: '10px'
      }}>
        <ul className='ant-pagination '>
          <li className={page === 1 ? ('ant-pagination-disabled ant-pagination-prev') : ('ant-pagination-prev')}>
            <a onClick={() => handlePrev()}>Anterior</a>
          </li>
          <li className='ant-pagination-item ant-pagination-item-1 ant-pagination-item-active'>{page}</li>
          <li className={persons.length >= 10 ? ('ant-pagination-next') : ('ant-pagination-disabled ant-pagination-next')}>
            <a onClick={() => handleNext}>Siguiente</a>
          </li>
        </ul>
      </div>
    </div>
  )
}
export default PersonsList